
import CardTravelOutlinedIcon from '@mui/icons-material/CardTravelOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import TitleOutlinedIcon from '@mui/icons-material/TitleOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import PublishedWithChangesOutlinedIcon from '@mui/icons-material/PublishedWithChangesOutlined';
import TaskOutlinedIcon from '@mui/icons-material/TaskOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';

const imageArray = [
    { imageUrl: <CardTravelOutlinedIcon/>, color: "rgba(6, 190, 108, 0.05)", iconColor: "#0fd17b" },
    { imageUrl: <DescriptionOutlinedIcon />, color: "rgba(20, 115, 252, 0.05)", iconColor: "#1473fc" },
    { imageUrl: <TitleOutlinedIcon />,  color: "rgba(146, 45, 136, 0.05)", iconColor: "#922d88" },
    { imageUrl: <PublishedWithChangesOutlinedIcon/>,  color: "rgba(253, 127, 35, 0.05)", iconColor: "#1db5d8"},
    { imageUrl: <LabelOutlinedIcon/>, color: "rgba(29, 181, 216, 0.05)", iconColor: "#443fb1" },
    { imageUrl: <TaskOutlinedIcon/>, color: "rgba(68, 63, 177, 0.05)", iconColor: "#443fb1" },
    { imageUrl: <VerifiedIcon/>, color: "rgba(6, 190, 108, 0.05)", iconColor: "#0fd17b" },];

export default imageArray;